export enum PermissionsList {
  // HOME_PAGE - Dashboard
  DispatcherHomeView = 1,
  DispatcherHomeCreate = 2,
  DispatcherHomeEdit = 3,
  DispatcherHomeDelete = 4,
  DispatcherHomeArchive = 5,

  // DISTRICTS_PAGE
  DispatcherDistrictsView = 11,
  DispatcherDistrictsCreate = 12,
  DispatcherDistrictsEdit = 13,
  DispatcherDistrictsDelete = 14,
  DispatcherDistrictsArchive = 15,

  // STUDENTS_PAGE
  DispatcherStudentsView = 16,
  DispatcherStudentsCreate = 17,
  DispatcherStudentsEdit = 18,
  DispatcherStudentsDelete = 19,
  DispatcherStudentsArchive = 20,

  // INCIDENT_REPORT_PAGE
  DispatcherIncidentReportView = 21,
  DispatcherIncidentReportCreate = 22,
  DispatcherIncidentReportEdit = 23,
  DispatcherIncidentReportDelete = 24,
  DispatcherIncidentReportArchive = 25,

  // ROUTING_REQUESTS_PAGE
  DispatcherRoutingRequestsView = 26,
  DispatcherRoutingRequestsCreate = 27,
  DispatcherRoutingRequestsEdit = 28,
  DispatcherRoutingRequestsDelete = 29,
  DispatcherRoutingRequestsArchive = 30,

  // VIDEO_REQUESTS_PAGE
  DispatcherVideoRequestsView = 31,
  DispatcherVideoRequestsCreate = 32,
  DispatcherVideoRequestsEdit = 33,
  DispatcherVideoRequestsDelete = 34,
  DispatcherVideoRequestsArchive = 35,
  DispatcherVideoRequestsDownloadVideo = 203,

  // DRIVERS_PAGE
  DispatcherDriversView = 36,
  DispatcherDriversCreate = 37,
  DispatcherDriversEdit = 38,
  DispatcherDriversDelete = 39,
  DispatcherDriversArchive = 40,

  // Advance Permission fro driver Assignment
  TimeExtentionEdit = 171,

  // GUARDIANS_PAGE
  DispatcherGuardiansView = 41,
  DispatcherGuardiansCreate = 42,
  DispatcherGuardiansEdit = 43,
  DispatcherGuardiansDelete = 44,
  DispatcherGuardiansArchive = 45,

  // MESSAGING_PAGE
  DispatcherMessagingView = 46,
  DispatcherMessagingCreate = 47,
  DispatcherMessagingEdit = 48,
  DispatcherMessagingDelete = 49,
  DispatcherMessagingArchive = 50,

  // SYSTEM_USERS_PAGE
  DispatcherSystemUsersView = 51,
  DispatcherSystemUsersCreate = 52,
  DispatcherSystemUsersEdit = 53,
  DispatcherSystemUsersDelete = 54,
  DispatcherSystemUsersArchive = 55,

  // ROLES_PERMISSIONS_PAGE
  DispatcherRolesPermissionsView = 56,
  DispatcherRolesPermissionsCreate = 57,
  DispatcherRolesPermissionsEdit = 58,
  DispatcherRolesPermissionsDelete = 59,
  DispatcherRolesPermissionsArchive = 60,

  // TOOLS_PAGE
  DispatcherToolsView = 61,
  DispatcherToolsCreate = 62,
  DispatcherToolsEdit = 63,
  DispatcherToolsDelete = 64,
  DispatcherToolsArchive = 65,

  // REGIONS_LOCATIONS_PAGE
  DispatcherRegionsAndLocationsView = 66,
  DispatcherRegionsAndLocationsCreate = 67,
  DispatcherRegionsAndLocationsEdit = 68,
  DispatcherRegionsAndLocationsDelete = 69,
  DispatcherRegionsAndLocationsArchive = 70,

  // LOCATIONS_PAGE
  DispatcherLocationsView = 166,
  DispatcherLocationsCreate = 167,
  DispatcherLocationsEdit = 168,
  DispatcherLocationsDelete = 169,
  DispatcherLocationsArchive = 170,

  // SCHOOLS_PAGE
  DispatcherSchoolsView = 71,
  DispatcherSchoolsCreate = 72,
  DispatcherSchoolsEdit = 73,
  DispatcherSchoolsDelete = 74,
  DispatcherSchoolsArchive = 75,

  // DRIVERS_ALERT_PAGE
  DispatcherDriversAlertView = 76,
  DispatcherDriversAlertCreate = 77,
  DispatcherDriversAlertEdit = 78,
  DispatcherDriversAlertDelete = 79,
  DispatcherDriversAlertArchive = 80,

  // RIDE_CANCELATION_REQUESTS_PAGE
  DispatcherRideCancelationRequestsView = 81,
  DispatcherRideCancelationRequestsCreate = 82,
  DispatcherRideCancelationRequestsEdit = 83,
  DispatcherRideCancelationRequestsDelete = 84,
  DispatcherRideCancelationRequestsArchive = 85,

  // LOGIN_AUDIT_PAGE
  DispatcherLoginAuditReportView = 86,
  DispatcherLoginAuditReportCreate = 87,
  DispatcherLoginAuditReportEdit = 88,
  DispatcherLoginAuditReportDelete = 89,
  DispatcherLoginAuditReportArchive = 90,

  // LOCATION_KIOSK_PAGE
  DispatcherLocationKiosksView = 91,
  DispatcherLocationKiosksCreate = 92,
  DispatcherLocationKiosksEdit = 93,
  DispatcherLocationKiosksDelete = 94,
  DispatcherLocationKiosksArchive = 95,

  // VEHICLES_PAGE
  DispatcherVehiclesView = 96,
  DispatcherVehiclesCreate = 97,
  DispatcherVehiclesEdit = 98,
  DispatcherVehiclesDelete = 99,
  DispatcherVehiclesArchive = 100,

  // DRIVERS_ASSIGNMENTS_PAGE
  DispatcherDriversAssignmentsView = 101,
  DispatcherDriversAssignmentsCreate = 102,
  DispatcherDriversAssignmentsEdit = 103,
  DispatcherDriversAssignmentsDelete = 104,
  DispatcherDriversAssignmentsArchive = 105,

  // Customer_Home_PAGE
  CustomerHomeView = 106,
  CustomerHomeCreate = 107,
  CustomerHomeEdit = 108,
  CustomerHomeDelete = 109,
  CustomerHomeArchive = 110,

  // Customer_Video_Requests_PAGE
  CustomerVideoRequestsView = 111,
  CustomerVideoRequestsCreate = 112,
  CustomerVideoRequestsEdit = 113,
  CustomerVideoRequestsDelete = 114,
  CustomerVideoRequestsArchive = 115,
  CustomerVideoRequestsDownloadVideo = 197,

  //Customer_Incidents_Report_PAGE
  CustomerIncidentsReportView = 116,
  CustomerIncidentsReportCreate = 117,
  CustomerIncidentsReportEdit = 118,
  CustomerIncidentsReportDelete = 119,
  CustomerIncidentsReportArchive = 120,

  //Customer_Routing_Requests_PAGE
  CustomerRoutingRequestsView = 121,
  CustomerRoutingRequestsCreate = 122,
  CustomerRoutingRequestsEdit = 123,
  CustomerRoutingRequestsDelete = 124,
  CustomerRoutingRequestsArchive = 125,

  //Customer_Messages_PAGE
  CustomerMessagesView = 126,
  CustomerMessagesCreate = 127,
  CustomerMessagesEdit = 128,
  CustomerMessagesDelete = 129,
  CustomerMessagesArchive = 130,

  //Dispatcher_Contacts_PAGE
  DispatcherContactsView = 131,
  DispatcherContactsCreate = 132,
  DispatcherContactsEdit = 133,
  DispatcherContactsDelete = 134,
  DispatcherContactsArchive = 135,

  //Dispatcher_JobTitle_PAGE
  DispatcherJobTitleView = 136,
  DispatcherJobTitleCreate = 137,
  DispatcherJobTitleEdit = 138,
  DispatcherJobTitleDelete = 139,
  DispatcherJobTitleArchive = 140,

  //Dispatcher_Responsabilities_PAGE
  DispatcherResponsabilitiesView = 141,
  DispatcherResponsabilitiesCreate = 142,
  DispatcherResponsabilitiesEdit = 143,
  DispatcherResponsabilitiesDelete = 144,
  DispatcherResponsabilitiesArchive = 145,

  //Dispatcher_Calender_PAGE
  DispatcherCalenderView = 146,
  DispatcherCalenderCreate = 147,
  DispatcherCalenderEdit = 148,
  DispatcherCalenderDelete = 149,
  DispatcherCalenderArchive = 150,

  //Dispatcher_Customers_Roles_&_Permissions_PAGE
  DispatcherCustomersRolesAndPermissionsView = 151,
  DispatcherCustomersRolesAndPermissionsCreate = 152,
  DispatcherCustomersRolesAndPermissionsEdit = 153,
  DispatcherCustomersRolesAndPermissionsDelete = 154,
  DispatcherCustomersRolesAndPermissionsArchive = 155,

  //Customer_Calender_PAGE
  CustomerCalenderView = 156,
  CustomerCalenderCreate = 157,
  CustomerCalenderEdit = 158,
  CustomerCalenderDelete = 159,
  CustomerCalenderArchive = 160,

  //Customer_Contacts_PAGE
  CustomerContactsView = 161,
  CustomerContactsCreate = 162,
  CustomerContactsEdit = 163,
  CustomerContactsDelete = 164,
  CustomerContactsArchive = 165,

  //DispatcherPersonalInfoView_PAGE
  DispatcherPersonalInfoView = 172,
  DispatcherPersonalInfoEdit = 174,

  //DispatcherEmailNotificationsView
  DispatcherEmailNotificationsView = 192,
  DispatcherEmailNotificationsEdit = 194,
  DispatcherSystemNotificationsView = 219,
  DispatcherSystemNotificationsEdit = 221,

  //notification catogires_PAGE
  DispatcherCalendarAndEmailView = 177,
  DispatcherMessagingEmailsView = 182,
  DispatcherClientRequestEmailsView = 187,
  DispatcherNotificationSoundView = 214,

  //districts users page.
  DispatcherDistrictsUsersView = 198,
  DispatcherDistrictsUsersCreate = 199,
  DispatcherDistrictsUsersEdit = 200,
  DispatcherDistrictsUsersDelete = 201,
  DispatcherDistrictsUsersArchive = 202,

  //live map users page.
  DispatcherLiveMapUsersView = 204,
  DispatcherLiveMapUsersCreate = 205,
  DispatcherLiveMapUsersEdit = 206,
  DispatcherLiveMapUsersDelete = 207,
  DispatcherLiveMapUsersArchive = 208,

  //route assignment users page.
  DispatcherRouteAssignmentUsersView = 209,
  DispatcherRouteAssignmentUsersCreate = 210,
  DispatcherRouteAssignmentUsersEdit = 211,
  DispatcherRouteAssignmentUsersDelete = 212,
  DispatcherRouteAssignmentUsersArchive = 213,

  //Customer_Bulletin-Board_PAGE
  DispatcherAnnouncementView = 259,
  DispatcherAnnouncementCreate = 260,
  DispatcherAnnouncementEdit = 261,
  DispatcherAnnouncementDelete = 262,

  //Setting_Zone_Category_PAGE
  DispatcherZoneCategoryView = 263,
  DispatcherZoneCategoryCreate = 264,
  DispatcherZoneCategoryEdit = 265,
  DispatcherZoneCategoryDelete = 266,

  //Map_Interest_Zone_PAGE
  DispatcherInterestZoneView = 267,
  DispatcherInterestZoneCreate = 268,
  DispatcherInterestZoneEdit = 269,
  DispatcherInterestZoneDelete = 270,

  // VEHICLES_PAGE
  DispatcherVehiclesLinkCustomer = 271,

  CustomerLiveMapView = 272,
  CustomerLiveMapCreate = 273,
  CustomerLiveMapEdit = 274,
  CustomerLiveMapDelete = 275,
  CustomerLiveMapArchive = 276,

  DispatcherUsageReportView = 277,
  DispatcherUsageReportCreate = 278,
  DispatcherUsageReportEdit = 279,
  DispatcherUsageReportDelete = 280,
  DispatcherUsageReportArchive = 281,

  DispatcherHistoricalVehiclesReportView = 282,
  DispatcherHistoricalVehiclesReportCreate = 283,
  DispatcherHistoricalVehiclesReportEdit = 284,
  DispatcherHistoricalVehiclesReportDelete = 285,
  DispatcherHistoricalVehiclesReportArchive = 286,

  DispatcherRunManagementView = 287,
  DispatcherRunManagementCreate = 288,
  DispatcherRunManagementEdit = 289,
  DispatcherRunManagementDelete = 290,
  DispatcherRunManagementArchive = 291,

  DispatcherRouteManagementView = 292,
  DispatcherRouteManagementCreate = 293,
  DispatcherRouteManagementEdit = 294,
  DispatcherRouteManagementDelete = 295,
  DispatcherRouteManagementArchive = 296,

  DispatcherTaskManagementView = 297,
  DispatcherTaskManagementCreate = 298,
  DispatcherTaskManagementEdit = 299,
  DispatcherTaskManagementDelete = 300,
  DispatcherTaskManagementArchive = 301,

  DispatcherLocationsYardsView = 302,
  DispatcherLocationsYardsCreate = 303,
  DispatcherLocationsYardsEdit = 304,
  DispatcherLocationsYardsDelete = 305,
  DispatcherLocationYardArchive = 306,

  DispatcherTaskCodeView = 307,
  DispatcherTaskCodeCreate = 308,
  DispatcherTaskCodeEdit = 309,
  DispatcherTaskCodeDelete = 310,
  DispatcherTaskCodeArchive = 311,

  DispatcherDashboardBIView = 317,
  DispatcherDashboardBICreate = 318,
  DispatcherDashboardBIEdit = 319,
  DispatcherDashboardBIDelete = 320,
  DispatcherDashboardBIArchive = 321,

  DispatcherTimeVerificationView = 322,
  DispatcherTimeVerificationCreate = 323,
  DispatcherTimeVerificationEdit = 324,
  DispatcherTimeVerificationDelete = 325,
  DispatcherTimeVerificationArchive = 326,
}

export enum BISettingsPermissionsScreenCodes {
  UsersAndPermissions = 301,
  RolesAndPermissions = 302,
}
